import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import Translation from '../../../../common/translation/translation.component';
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { withRouter } from 'react-router-dom';
import {
    ORFButton
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_InputField as InputField
} from '../../../../common/forms/order-request-form.component';
import { Row, Col } from 'react-bootstrap';
import Icons from '../../../../icon';
import { trueFalseToBoolean } from '../../../../../utils/helpers.utils';
import { wirelineOtherRequestActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-other-request.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../store/external/common-reducer/file-attachment.reducer";
import { CIRCUIT_STATUS, SUBMIT_REQUEST, SUBMIT_REQUEST_TITLE, MAX_LENGTH } from '../../../../../constants/external-constants';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { requestDetailsActions } from '../../../../../store/external/request-reducer/request-details.reducer';
import { Loading } from '../../../../common/loading';

class WirelineOtherForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            localToggle: false,
            alterToggle: false,
            showContactFormInfo: false,
            error: false,
            showConModal:false,
            show:false,
            message:'',
            isLoading: true,
        }
    }

 async componentDidMount() {
    const {
        isUpdateRequest,
        takeActionCircuitCode,
        takeActionCircuitId
    } = this.props.createRequest;

    const {
        requestDetail,
        onUpdateForm,
        fetchEmployeeByValue,
        fetchROBEmployeeByValue,
        fetchSubscriptionByValue,
        fetchSubscriptionByCircuitCode,
        onSubscriptionSelect
    } = this.props;

    this.props.fetchOtherOptions();

    const circuitCodePropName = 'CircuitCode';
    let subscriptionList = null;

    if (isUpdateRequest) {
        const selectedItem = requestDetail.requestData.Order;

        const currentCircuitCode =
            requestDetail.requestData.Circuit.CircuitId != null
                ? requestDetail.requestData.Circuit.CircuitCode
                : null;

        this.setState({ isLoading: true });

        if (selectedItem?.IsRequestedInBehalf) {

            if (currentCircuitCode != null) {
                await fetchSubscriptionByCircuitCode(
                    currentCircuitCode,
                    "CircuitCode",
                    selectedItem.IsRequestedInBehalf
                );
            }

            await fetchROBEmployeeByValue()
                .then(() =>
                    fetchEmployeeByValue(
                        requestDetail.requestData.WireLineApprover.Name,
                        'Name'
                    )
                )
                .then(() => onUpdateForm());

        } else {

            if (currentCircuitCode != null) {
                await fetchSubscriptionByValue(currentCircuitCode);
            }

            await fetchEmployeeByValue(
                requestDetail.requestData.WireLineApprover.Name,
                'Name'
            );

            await onUpdateForm();
        }

    } else {

        const hasCircuit =
            takeActionCircuitId != null ||
            (takeActionCircuitCode != null && takeActionCircuitCode !== '');

        if (hasCircuit) {

            subscriptionList = await fetchSubscriptionByValue(
                takeActionCircuitCode,
                circuitCodePropName
            );

            onSubscriptionSelect(
                takeActionCircuitCode,
                circuitCodePropName,
                subscriptionList,
                null,
                takeActionCircuitId
            );

        } else {
            onSubscriptionSelect('');
        }
    }

    this.setState({ isLoading: false });
}

    componentWillUnmount() {
        this.props.resetWirelineOtherRequestForm();
        this.props.resetRequestData();
        this.props.resetFileAttachment();
    }

    submitRequest = async () => {
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
        const { submitRequest, fetchRequestLogItems } = this.props;
        if (buttonType === CONFIRMATION_VALUE.Ok) {
             
              this.setState( prev => ({
                isSaving:true,
             }))

            var success = await submitRequest();
            if (success.Success) {
                this.setState({
                    title:"Success"
                })
                this.props.hideRequestModal(); 
                fetchRequestLogItems(0);
            }else {
                this.setState({
                    title:"Error"
                })
            }
            this.setState( prev => ({
                showConModal: !prev.showConModal,
                show:true, 
                isSaving:false,                   
                message:success.Message
            }))
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    handleCloseNotif = () => {
        this.setState({ show: false, isSaving:false });
        if(this.state.title!=="Error")
        {            
            this.props.history.goBack();
        }
    }

    render() {
        const {
            //form
            wirelineOtherRequestFormA
            //reducer action
            , onSubscriptionSelect
            , onEmployeeSelect
            , fetchSubscriptionByValue
            , fetchEmployeeByValue
            , onChangeExpedite
        } = this.props;

        const { showContactFormInfo } = this.state;

        const { subscriptionList, employeeList, takeActionCircuitCode, isUpdateRequest } = this.props.createRequest;
        const { otherOptions, formSubmitted, subscription, isResetLoading } = this.props.wirelineOtherRequestRequest;
        const { requestData } = this.props.requestDetail;

        const initialRequired= ( wirelineOtherRequestFormA.otherRequestTypeId !== '32' && wirelineOtherRequestFormA.circuitId == 0)
            || wirelineOtherRequestFormA.wireLineApproverId == 0
            || wirelineOtherRequestFormA.otherRequestTypeId == ''

            || (trueFalseToBoolean(wirelineOtherRequestFormA.expediteRequest) && wirelineOtherRequestFormA.businessJustification == '')
            || formSubmitted;

        const updateRequired = isUpdateRequest ? !((requestData?.Circuit?.CircuitId != null ? requestData?.Circuit?.CircuitId != wirelineOtherRequestFormA?.circuitId : wirelineOtherRequestFormA?.circuitId != 0)
            || (requestData?.Circuit?.CircuitCode != 'N/A' ? requestData?.Circuit?.CircuitCode != wirelineOtherRequestFormA?.circuitCode : wirelineOtherRequestFormA?.circuitCode != '')
            || requestData.Order.RequestType.RequestTypeID.toString() != wirelineOtherRequestFormA.otherRequestTypeId
            || requestData.WireLineApprover.EmployeeId != wirelineOtherRequestFormA.wireLineApproverId
            || requestData.BusinessWireline.ExpediteRequest.toString() != wirelineOtherRequestFormA.expediteRequest
            || requestData.BusinessJustification.BusinessJustification != wirelineOtherRequestFormA.businessJustification
            || requestData.BusinessJustification.AdditionalInformation != wirelineOtherRequestFormA.additionalInformation
        ) : false;

        let expediteOptions = [
            {
                "Key": true,
                "Value": "Yes"
            },
            {
                "Key": false,
                "Value": "No"
            }
        ];

        if (this.state.isLoading) {
            return <Loading />
        }  

        return (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal confirmation-blur-background notification-footer modal-text-bold'}
                />

                 <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? SUBMIT_REQUEST.updateRequest : SUBMIT_REQUEST.submitRequest}
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest :SUBMIT_REQUEST_TITLE.submitRequest}
                    handleModal={this.handleConfirmationModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal confirmation-blur-background modal-text-bold'}
                />
                <Form method="post" role="form"
                    model="wirelineOtherRequestFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('Request')}`}
                                value={wirelineOtherRequestFormA.otherRequestTypeId}
                                options={otherOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.otherRequestTypeId'                              
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className={`${parseInt(wirelineOtherRequestFormA.otherRequestTypeId) !== 32 ? 'required':''} subscription_container`}>
                            {
                            !isResetLoading &&

                            <SearchSuggestions
                                value={wirelineOtherRequestFormA.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')}`}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                                //defaultValue={takeActionCircuitCode}
                                errorMessage={this.toLocaleLanguage('error_subscription_not_exist')}
                                haveError={this.haveError}                               
                                />
                            }
                            {wirelineOtherRequestFormA.circuitCode != '' &&
                                <div className="sub-label__input-field">
                                    <span className={subscription.CircuitStatus === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{subscription.CircuitStatus} </span> <span>| </span>
                                    {subscription.VendorName ? subscription.VendorName : <Translation translationKey="no_vendor" />} <span>| </span>
                                    {subscription.CircuitTypeName ? subscription.CircuitTypeName : <Translation translationKey="no_circuit_type_available" />} <span>| </span>
                                    {subscription.SubCircuitTypeName ? subscription.SubCircuitTypeName : <Translation translationKey="no_sub_circuit_type_available" />}
                                </div>
                            }
                        </Col>
                    </Row>                   
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required custom-margin'>
                        {
                            !isResetLoading &&
                            <SearchSuggestions
                                value={wirelineOtherRequestFormA.employeeEmail}
                                label={`${this.toLocaleLanguage('approver')}`}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                propDisplay={'Name'}
                                options={employeeList.length > 0 ? employeeList : ''}
                                onChangeAction={onEmployeeSelect}
                                searchAction={fetchEmployeeByValue}
                                key={wirelineOtherRequestFormA.circuitCode || wirelineOtherRequestFormA.employeeEmail}
                                />
                        }
                        </Col>
                    </Row>
                    {
                        showContactFormInfo &&
                        <div className="local-contact-container" onClick={this.toggleLocalContainer.bind(this)}>
                            <Icons
                                customClassName="icon-circle-plus"
                                name={this.state.localToggle ? `circle-minus-reg` : `circle-plus-reg`}
                                size="20px"
                                containerClass="icon-circle-plus-container"
                            />
                            <h1 className="local-contact-header"><Translation translationKey="local_contact_title" /></h1>
                        </div>
                    }                    
                    {this.state.localToggle ?
                        <div className="local-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_email_address')} *`}
                                        value={wirelineOtherRequestFormA.localContactEmail}
                                        fieldProp='.localContactEmail'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_fullname')} *`}
                                        value={wirelineOtherRequestFormA.localContactFullName}
                                        fieldProp='.localContactFullName'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_phone_number')} *`}
                                        value={wirelineOtherRequestFormA.localContactPhone}
                                        fieldProp='.localContactPhone'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>
                        : ""}
                        {
                            showContactFormInfo &&
                            <div className="local-contact-container" onClick={this.toggleAlterContainer.bind(this)}>
                                <Icons
                                    customClassName="icon-circle-plus"
                                    name={this.state.alterToggle ? `circle-minus-reg` : `circle-plus-reg`}
                                    size="20px"
                                    containerClass="icon-circle-plus-container"
                                />
                                <h1 className="local-contact-header"><Translation translationKey="alt_local_contact_title" /></h1>
                            </div>
                        }
                    
                    {this.state.alterToggle ?
                        <div className="alter-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_email_address')} *`}
                                        value={wirelineOtherRequestFormA.altLocalContactEmail}
                                        fieldProp='.altLocalContactEmail'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_full_name')} *`}
                                        value={wirelineOtherRequestFormA.altLocalContactFullName}
                                        fieldProp='.altLocalContactFullName'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_phone_number')} *`}
                                        value={wirelineOtherRequestFormA.altLocalContactPhone}
                                        fieldProp='.altLocalContactPhone'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>

                        : ""}
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required custom-margin'>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('expedite_request')}`}
                                value={wirelineOtherRequestFormA.expediteRequest}
                                onChangeAction={onChangeExpedite}
                                options={expediteOptions}
                                fieldProp='.expediteRequest'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className={`${trueFalseToBoolean(wirelineOtherRequestFormA.expediteRequest) ? 'required' : ''} custom-margin`}>
                            <TextArea
                                label={`${this.toLocaleLanguage('business_justification')}`}
                                fieldProp='.businessJustification'
                                value={wirelineOtherRequestFormA.businessJustification}
                                disabled={!trueFalseToBoolean(wirelineOtherRequestFormA.expediteRequest)}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_500}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelineOtherRequestFormA.additionalInformation}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_1000}
                            />
                        </Col>
                    </Row>                   
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={isUpdateRequest ? (initialRequired || updateRequired) : initialRequired}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter(connect(
    state => {
        const { wirelineOtherRequestRequest, createRequest, translation, requestDetail } = state;
        const { wirelineOtherRequestFormA } = state.form;
        return {
            wirelineOtherRequestRequest
            , wirelineOtherRequestFormA
            , createRequest
            , requestDetail
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelineOtherRequestActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions
                , requestDetailsActions
            ),
            dispatch
        )
)(WirelineOtherForm));